import React from 'react';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import { setIfNull, setTrim } from '../../../../lib/common';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import TextArea from '../../../../components/input/TextArea/TextArea';
import { _LIST_PAGINATION_MODEL, LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  POINT_RANKING_LIST_SEARCH_DATA_MODEL,
  POINT_RANKING_LIST_SEARCH_OPTION_MODEL,
} from '../../../../store/modules/point/models';
import {
  MAXIMUM_NUMBER_OF_SEARCH_BOX_REFERRAL_CODE,
  MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID,
  MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_NAME,
} from '../../../../constants/service/app/pointConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './PointRankingListSearchBox.scss';

const PointRankingListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { userId, userName, referralCode, issuedDate } = searchData;

  return (
    <SearchBox
      className="point-ranking-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: POINT_RANKING_LIST_SEARCH_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: POINT_RANKING_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*userId 로 검색 input*/}
      <BaseForm
        label="유저 ID"
        content={
          <div className="input-search-wrap">
            <TextArea
              value={userId}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID}
              onChange={(value) => {
                setData({
                  path: ['userId'],
                  value: setIfNull(setTrim(value)),
                });
              }}
              onPressEnter={() =>
                getList({
                  searchOption: searchData,
                  pagination: LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      <BaseForm
        label="회원 이름"
        content={
          <div className="input-search-wrap">
            <TextArea
              value={userName}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_NAME}
              onChange={(value) => {
                setData({
                  path: ['userName'],
                  value: setIfNull(setTrim(value)),
                });
              }}
              onPressEnter={() =>
                getList({
                  searchOption: searchData,
                  pagination: _LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      <BaseForm
        label="친구 추천 코드"
        content={
          <div className="input-search-wrap">
            <TextArea
              value={referralCode}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_REFERRAL_CODE}
              onChange={(value) => {
                setData({
                  path: ['referralCode'],
                  value: setIfNull(setTrim(value)),
                });
              }}
              onPressEnter={() =>
                getList({
                  searchOption: searchData,
                  pagination: _LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      <BaseForm
        label="포인트 로그 생성일"
        content={
          <div className="quick-date-picker">
            <DateRangePicker
              value={issuedDate}
              format={DATE_FORMAT.YMD_DASH_FORMAT}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(value) =>
                setData({
                  path: ['issuedDate'],
                  value,
                })
              }
            />
          </div>
        }
      />
    </SearchBox>
  );
};

export default PointRankingListSearchBox;
